import React, { useContext, useState } from "react"
import { Content } from "./style"
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from "../../../components/styles/subheader-style"
import { Outlet, useNavigate, useOutletContext } from "react-router-dom"
import people from '../../../assets/assesses/accesses.svg'
import key from '../../../assets/assesses/key.svg'
import { TypeMainOutlet } from ".."
import ModalContext from "../../../contexts/ModalContext"
import UserContext, { Roles } from "../../../contexts/UserContext"

export interface PeopleOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
}

const tabs = [
  { path: '', image: people, name: 'Usuários' },
  { path: 'profiles', image: key, name: 'Perfis de acesso' },
]

const PeopleSubHeader: React.FC<{ tabIndexActived: number }> = ({ tabIndexActived }) => {
  const { setModalSection, setModalActive, setEditingProfile } = useContext(ModalContext)
  const { user } = useContext(UserContext)
  const navigate = useNavigate()

  const isGlobalAdmin = user?.role === Roles.globalAdmin
  const isTenantAdmin = user?.role === Roles.tenantAdmin

  const firstTabName = isGlobalAdmin ? 'Tenants' : 'Usuários'
  const updatedTabs = [
    { path: '', image: people, name: firstTabName },
    { path: 'profiles', image: key, name: 'Perfis de acesso' },
  ]

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>Pessoas</SectionName>
        <TabsDiv>
          {updatedTabs.map((tab, index) => (
            <Tab
              key={index}
              $isFirst={index === 0}
              $isLast={index === updatedTabs.length - 1}
              $isActive={index === tabIndexActived}
              onClick={() => {
                if (index !== tabIndexActived) navigate(tab.path)
              }}
            >
              <img src={tab.image} alt={`${tab.path}-icon`} />
              {tab.name}
            </Tab>
          ))}
        </TabsDiv>
      </LeftSide>
      {tabIndexActived === 0 && isGlobalAdmin &&
        <RightSide>
          <ButtonCreate onClick={() => {
            setModalSection('createTenant')
            setModalActive(true)
          }}>+ Cadastrar tenant</ButtonCreate>
        </RightSide>
      }
      {tabIndexActived === 0 && isTenantAdmin &&
        <RightSide>
          <ButtonCreate onClick={() => {
            setModalSection('createAccessUser')
            setModalActive(true)
          }}>+ Cadastrar usuário</ButtonCreate>
        </RightSide>
      }
      {tabIndexActived === 1 && !isGlobalAdmin &&
        <RightSide>
          <ButtonCreate onClick={() => {
            setEditingProfile(null)
            setModalSection('createProfile')
            setModalActive(true)
          }}>+ Cadastrar perfil</ButtonCreate>
        </RightSide>
      }
    </SubHeaderContainer>
  )
}

const PeopleContent = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const { search } = useOutletContext<TypeMainOutlet>()

  return (
    <>
      <PeopleSubHeader tabIndexActived={tabIndex} />
      <Content>
        <Outlet
          context={{
            tabIndex,
            setTabIndex,
            search
          }}
        />
      </Content>
    </>
  )
}

export default PeopleContent